<template>
	<app-modal :sleep="sleepModal" :name="MODAL_NAME" :maxWidth="450" @beforeOpen="beforeOpen">
		<template v-slot:title>{{EDIT_MODE ? 'Редактирование полки' : 'Новая полка'}}</template>

		<template v-slot="{params}">
			<form action="#" method="post" @submit.prevent="submit({
					onSuccess: params.onSuccess
				})">

				<div class="mb-4">
					<label for="shelf-input-name">Название полки</label>
					<input id="shelf-input-name" ref="name-input" type="text" v-model="form.name" class="form-control" data-autofocus>
				</div>

				<div>
					<button type="submit" class="btn btn-primary">{{EDIT_MODE ? 'Сохранить' : 'Создать полку'}}</button>
				</div>

			</form>
		</template>

	</app-modal>
</template>
<script>
export default {
	data() {
		return {
			MODAL_NAME: 'shelf-instance',
			ID_SHELF: 0,
			CATEGORY: null,
			EDIT_MODE: false,

			sleepModal: false, // loader

			form: {
				name: '',
			}
		}
	},
	methods: {
		beforeOpen(e) {
			const data = e.ref.params.value;

			this.ID_SHELF   = Math.max(parseInt(data.idShelf) || 0, 0);
			this.CATEGORY  = data.category || null;
			this.EDIT_MODE = !!this.ID_SHELF;

			if (this.EDIT_MODE) {
				this.sleepModal = true;
				this.getData().then(response => {
					const data = response.data.id ? response.data : null;

					this.form = data ? _.objectPick(data, Object.keys(this.form)) : this.form;
					this.sleepModal = false;
				}).catch(() => this.sleepModal = false);
			}
		},

		getData() {
			return this.userapi.get(`racks/${this.ID_SHELF}`);
		},

		submit(params) {
			const eventSuccess = params.onSuccess || function() {};

			// выходим если нет данных либо submit уже активен
			if (!this.CATEGORY || this.sleepModal) {
				return;
			}

			// get name
			const name = this.form.name.trim();

			if (!name) {
				this.$refs['name-input'].focus();
				return;
			}

			// start loader
			this.sleepModal = true;

			const isEdit = this.EDIT_MODE;
			const request = new URLSearchParams();
			const requestUrl = `racks/${isEdit ? `edit/${this.ID_SHELF}` : 'add'}`

			request.append('name', name);
			request.append('category', this.CATEGORY.id);

			this.userapi.post(requestUrl, request).then(response => {

				if (!response.hasValidateErrors) {
					eventSuccess(isEdit ? 'edit' : 'add', response.data.data);
					this.$vfm.hide(this.MODAL_NAME);
				}

				this.sleepModal = false;
			}).catch(() => {
				this.sleepModal = false;
			});
		}
	},
}
</script>